var render = function render(_c,_vm){return _c('div',{staticClass:"grad-content"},[(_vm.$slots.left)?_c('aside',{staticClass:"grad-content__left"},[_vm._t("left")],2):_vm._e(),_c('main',{staticClass:"grad-content__main"},[_vm._t("default")],2),(_vm.$slots.right)?_c('aside',{staticClass:"grad-content__right"},[_vm._t("right")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }